import * as React from 'react'
import Button, { ButtonProps } from '@mui/material/Button'
import UseBtnColor, { GygBtnColorType } from '../@core/hooks/useButtonColor'
import { Typography } from '@mui/material'

interface GygButtonProps extends ButtonProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  text?: React.ReactNode | string
  textIcon?: React.ReactNode | string
  color: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning'
  size: 'small' | 'medium' | 'large'
  dataTestId?: string
}

const GygButton = (props: GygButtonProps) => {
  const { startIcon, endIcon, onClick, sx, disabled, text, size, color, type, textIcon, dataTestId } = props

  const bgColors = UseBtnColor()

  const colors: GygBtnColorType = {
    primary: { ...bgColors.primaryBtn },
    secondary: { ...bgColors.secondaryBtn },
    inherit: { ...bgColors.tertiaryBtn },
    error: { ...bgColors.errorBtn },
    success: { ...bgColors.successBtn },
    info: { ...bgColors.linkBtn }
  }

  const sizeStyles =
    size === 'large'
      ? { minWidth: '160px', maxWidth: '250px', height: '44px' }
      : size === 'small'
        ? { minWidth: '60px', height: '40px' }
        : { minWidth: '100px', maxWidth: '200px', height: '35px' }

  const mergedSx = {
    ...sizeStyles,
    border: `${
      (color === 'secondary' && typeof text === 'object') || color !== 'secondary' ? '0px' : '2px solid #FFD204'
    }`,
    borderRadius: '24px',
    opacity: disabled ? 0.5 : 1,
    ...(color ? colors[color] : {}),
    ...sx,
    backgroundColor:
      (color === 'secondary' || color === 'info') && typeof text === 'object'
        ? colors[color!].reloadColor
        : colors[color!].backgroundColor,
    ':hover': disabled
      ? {}
      : {
          backgroundColor: color && colors[color].hoverColor,
          ...sx
        }
  }

  return (
    <Button
      startIcon={startIcon}
      endIcon={endIcon}
      style={{ color: color === 'error' ? 'white' : 'black' }}
      onClick={onClick}
      sx={mergedSx}
      disabled={disabled}
      type={type}
      data-testid={dataTestId}
    >
      <Typography variant='body1' display={'flex'}>
        {textIcon ? textIcon : text}
      </Typography>
    </Button>
  )
}
export default GygButton
